import { FC, SVGProps } from 'react';

const InfoV2: FC<SVGProps<SVGSVGElement>> = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 0C25.3125 0 32.5 7.1875 32.5 16C32.5 24.875 25.3125 32 16.5 32C7.625 32 0.5 24.875 0.5 16C0.5 7.1875 7.625 0 16.5 0ZM16.5 30C24.1875 30 30.5 23.75 30.5 16C30.5 8.3125 24.1875 2 16.5 2C8.75 2 2.5 8.3125 2.5 16C2.5 23.75 8.75 30 16.5 30ZM16.5 11.5C15.625 11.5 15 10.875 15 10C15 9.1875 15.625 8.5 16.5 8.5C17.3125 8.5 18 9.1875 18 10C18 10.875 17.3125 11.5 16.5 11.5ZM19.5 22C20 22 20.5 22.5 20.5 23C20.5 23.5625 20 24 19.5 24H13.5C12.9375 24 12.5 23.5625 12.5 23C12.5 22.5 12.9375 22 13.5 22H15.5V16H14.5C13.9375 16 13.5 15.5625 13.5 15C13.5 14.5 13.9375 14 14.5 14H16.5C17 14 17.5 14.5 17.5 15V22H19.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InfoV2;
